import React from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, Team } from "..";

export const TeamSeeley = () => {
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const aboutDetails = useStore((state) => state.aboutDetails);

  const overlay = {
    where: "aboutSeeley",
    title: "Meet Seeley",
    // caption: "A caption",
  };
  const info = {
    routes: {
      Home: "/",
      "Todo's Team": getLink(pathTitles.MEETTHETEAM),
      "Meet Seeley": getLink(pathTitles.MEETSEELEY),
    },
    body: aboutDetails.SEELEY.body,
  };
  return (
    <>
      <SEO
        title="Meet Seeley — Todo's Translator Demo Dog"
        description="Meet Seeley, one of Todo's Translator's demonstration dogs. Read her story and see her role in Justine's programs."
        path="/meet-the-trainer/seeley"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <Team info={info} />
        </>
      )}
    </>
  );
};
